import angular from 'angular';
import { isNumber } from 'lodash';

module.exports = angular.module('common.filters.abs', [])
.filter('abs', function() {
  return function(input) {
    return isNumber(input) ? Math.abs(input) : input;
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/abs.js
 **/